import { client } from '../http';

export default {
  async saveActivationSurveyAnswers({ answers }) {
    return await client.post('/api/survey/activation', { answers });
  },
  async saveChurnSurveyAnswers({ customerId, subscriptionState, onStateSince, answers }) {
    return await client.post('/api/no-auth/survey/churn', { customerId, subscriptionState, onStateSince, answers });
  },
};
